__webpack_require__.p = "https://static.parastorage.com/services/restaurants-orders-ooi/bb8ae349e011b8332b5a3bdb0bfc554631264274749ab74e5046648d/";